import { FunctionComponent, useContext } from 'react'
import { DarkCoveProps } from './types/darkcove'
import usePlatformSpecificProps from './hooks/usePlatformSpecificProps'
import DarkCovePlayer from '@components/Video/Brightcove/DarkCovePlayer'
import VideoRecommendations from './recommendations/VideoRecommendations'
import { isVideoRecommendationsEnabled } from './recommendations/utils'
import BlickTVStoryContext from './story/BlickTVStoryContext'

const DarkCove: FunctionComponent<DarkCoveProps> = ({ videoId, ...rest }) => {
  const storyContext = useContext(BlickTVStoryContext)
  const props = usePlatformSpecificProps({
    ...rest,
    videoId: videoId || '',
  })

  if (!videoId) {
    return null
  }

  // TODO: refactor this
  storyContext.playerRef = props.ref

  return (
    <>
      {isVideoRecommendationsEnabled() ? (
        <VideoRecommendations
          playerRef={props.ref}
          videoId={props.videoId}
          videoPlayingStatus={props.videoPlayingStatus}
          isOverlay={props.isOverlay}
          isBlickTV={props.isBlickTV}
          title={rest.title}
          isInArticle={rest.isInArticle}
          hasPlaylist={rest.hasPlaylist}
          videoRecommendations={props.videoRecommendations}
        />
      ) : null}
      <DarkCovePlayer {...props} />
    </>
  )
}

export default DarkCove
